// resources/js/Pages/Formula/SortableItem.js
import React, { useRef } from 'react';
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import { useDndContext } from '@dnd-kit/core'; // ✅ Import useDndContext

export default function SortableItem({ id, children, activeId, node }) { // ✅ Add `node` prop
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isOver,
  } = useSortable({ id });
  
  // ✅ FIX: Get the global D&D context to identify the current drop target.
  const { over, active } = useDndContext();
  const nodeRef = useRef(null);

  const isBeingDragged = activeId === id;

  // ✅ FIX: This is the core logic to prevent the jump.
  // We check if this item is a container (like a Section) and if the user is
  // currently trying to drop something ON or INSIDE it.
  const isContainer = node && node.children !== undefined;
  const isDropTarget = over && (over.id === id || over.data?.current?.parentId === id);

  // If it's a container being targeted for a drop, we nullify the transform
  // that the parent sorting strategy tries to apply. This stops the jump.
  const finalTransform = isContainer && isDropTarget ? null : transform;

  const style = {
    transform: CSS.Transform.toString(finalTransform), // ✅ Use our conditional transform
    transition: isBeingDragged ? 'none' : transition,
    opacity: isBeingDragged ? 0 : 1,
    pointerEvents: isBeingDragged ? 'none' : 'auto',
  };

  const overNodeRect = over && over.id === id ? nodeRef.current?.getBoundingClientRect() : null;
  const draggingRect = active ? active.rect.current.translated : null;

  return (
    <div 
      ref={(el) => {
        setNodeRef(el);
        nodeRef.current = el;
      }} 
      style={style} 
      {...attributes}
      data-sortable-item="true"
      data-is-dragging={isBeingDragged}
    >
      {children(listeners, isOver, overNodeRect, draggingRect)}
    </div>
  );
}